module.exports = __webpack_public_path__ + "static/media/Drenagem.207e71d5.svg";